// hooks/usePersistedState.ts
import { useState } from 'react';

export function usePersistedState<T>(key: string, defaultValue: T): [T, (value: T | ((prev: T) => T)) => void] {
  const [state, setState] = useState<T>(() => {
    const saved = sessionStorage.getItem(key);
    return saved ? (JSON.parse(saved) as T) : defaultValue;
  });

  const setPersistedState = (value: T | ((prev: T) => T)) => {
    setState(prev => {
      const next = typeof value === 'function' ? (value as (prev: T) => T)(prev) : value;
      sessionStorage.setItem(key, JSON.stringify(next));
      return next;
    });
  };

  return [state, setPersistedState];
}